import { render } from "./EmailMange.vue?vue&type=template&id=56be1a32&scoped=true"
import script from "./EmailMange.vue?vue&type=script&lang=js"
export * from "./EmailMange.vue?vue&type=script&lang=js"

import "./EmailMange.vue?vue&type=style&index=0&id=56be1a32&lang=scss&scoped=true"
import "./EmailMange.vue?vue&type=style&index=1&id=56be1a32&lang=scss"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56be1a32"]])

export default __exports__